import PropTypes from "prop-types";
import { IconBag, IconGrid, IconQrScanner, IconUser } from "mobile/components/MobileNavIcons";
import { vbs } from "../lib/theme";

const HERO_SIZE = 26;
const NAV_SIZE = 24;

function iconSx(hero, size) {
  return {
    color: hero ? "rgba(255,255,255,0.94)" : vbs.ink,
    opacity: hero ? 1 : 0.9,
    width: size,
    height: size,
  };
}

export function VbsHeaderCatalogIcon({ hero = false, size }) {
  const s = size || (hero ? HERO_SIZE : NAV_SIZE);
  return <IconGrid sx={iconSx(hero, s)} fontSize={s} />;
}

/** QR scanner — sale / install registration (matches native app). */
export function VbsHeaderQrScanIcon({ hero = false, size }) {
  const s = size || (hero ? HERO_SIZE : NAV_SIZE);
  return <IconQrScanner sx={iconSx(hero, s)} fontSize={s} />;
}

/** @deprecated Use VbsHeaderQrScanIcon */
export function VbsHeaderWarrantyIcon(props) {
  return <VbsHeaderQrScanIcon {...props} />;
}

export function VbsHeaderAccountIcon({ hero = false, size }) {
  const s = size || (hero ? HERO_SIZE : NAV_SIZE);
  return <IconUser sx={iconSx(hero, s)} fontSize={s} />;
}

export function VbsHeaderCartIcon({ hero = false, size }) {
  const s = size || (hero ? HERO_SIZE : NAV_SIZE);
  return <IconBag sx={iconSx(hero, s)} fontSize={s} />;
}

const iconPropTypes = {
  hero: PropTypes.bool,
  size: PropTypes.number,
};

const iconDefaultProps = {
  hero: false,
  size: null,
};

VbsHeaderCatalogIcon.propTypes = iconPropTypes;
VbsHeaderCatalogIcon.defaultProps = iconDefaultProps;
VbsHeaderQrScanIcon.propTypes = iconPropTypes;
VbsHeaderQrScanIcon.defaultProps = iconDefaultProps;
VbsHeaderWarrantyIcon.propTypes = iconPropTypes;
VbsHeaderWarrantyIcon.defaultProps = iconDefaultProps;
VbsHeaderAccountIcon.propTypes = iconPropTypes;
VbsHeaderAccountIcon.defaultProps = iconDefaultProps;
VbsHeaderCartIcon.propTypes = iconPropTypes;
VbsHeaderCartIcon.defaultProps = iconDefaultProps;

export { HERO_SIZE, NAV_SIZE };
